import {
  Component,
  OnInit,
  ViewChild,
  inject,
  AfterViewInit,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { firstValueFrom, Observable } from 'rxjs';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { selfcreditService } from '../self-credit.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UsersService } from '../../users.service';
import { HttpClient } from '@angular/common/http';

interface TabItem {
  id: string;
  value: number;
  title: string;
  icon: string;
  active: boolean;
}

@Component({
  selector: 'app-userlist',
  templateUrl: './self-credit.component.html',
  styleUrls: ['./self-credit.component.scss'],
  providers: [DecimalPipe],
})

/**
 * Contacts user-list component
 */
export class SelfCreditComponent implements OnInit, AfterViewInit {
  /* NUEVO */
  activeTab: string = 'personal';

  tabs: TabItem[] = [
    {
      id: 'personal',
      value: 0,
      title: 'Datos Personales',
      icon: '👤',
      active: true,
    },
    {
      id: 'laboral',
      value: 1,
      title: 'Información Laboral',
      icon: '💼',
      active: false,
    },
    {
      id: 'financiera',
      value: 2,
      title: 'Información Financiera',
      icon: '💰',
      active: false,
    },
    {
      id: 'credito',
      value: 3,
      title: 'Información de Crédito',
      icon: '📍',
      active: false,
    },
    {
      id: 'bancaria',
      value: 4,
      title: 'Información Bancaria',
      icon: '💲',
      active: false,
    },
  ];

  /* NUEVO - DATOS GEOGRAFICOS */
  paises: any[] = [{ nombre: 'Colombia', codigo: 'CO' }];
  departamentos: any[] = [];
  municipios: any[] = [];
  colombiaData: any[] = [];
  private http = inject(HttpClient);

  // bread crumb items
  private fb = inject(FormBuilder);

  isLinear = false;
  breadCrumbItems: Array<{}>;
  haveUser = false;

  Clientlist!: Observable<any[]>;
  total: Observable<number>;

  id;
  submitted = false;
  contacts: any;
  files: File[] = [];
  loading = false;
  listData: any;
  habilitado: any;
  textittle: any;
  valorTotalCredito;
  itemSearch: any;
  listado: any;

  validateDocument: boolean = false;
  isUser = false;

  clientes: boolean = false;
  clientesArray: any[] = [];

  displayedColumnsClients: string[] = [
    'id',
    'nombres',
    'apellidos',
    'correo',
    'identificacion',
    'estado',
    'accion',
  ];
  dataSourceClients!: MatTableDataSource<any>;
  @ViewChild('paginatorClients', { static: true })
  paginatorClients!: MatPaginator;
  @ViewChild('sortClients') sortClients!: MatSort;

  nombreP: string;
  apellidosP: string;
  identificacionP: string;
  idclienteP: string;
  correo: string;
  listaDeCreditosFiltrada: [] = [];
  modalAbierto: boolean;
  listBanks: any;

  userId: any;
  user: {};

  anteriorTab: number;
  actualTabValida: number;

  requestForm: FormGroup = this.fb.group({
    id: [0],
    name: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    fullName: [''],
    documentType: ['', [Validators.required]],
    documentNumber: ['', [Validators.required, Validators.minLength(6)]],
    customerDocument: [''],
    country: ['CO', [Validators.required]],
    department: ['', [Validators.required]],
    city: ['', [Validators.required]],
    address: ['', [Validators.required]],
    birthDate: [''],
    cellPhone: ['', [Validators.required]],
    documents: [],
    email: ['', [Validators.required]],
    gender: ['', [Validators.required]],

    employeeType: ['', [Validators.required]],
    enterpriseName: [''],
    contractType: [''],
    neighborhood: [''],
    position: [''],

    incoming: ['', [Validators.required]],
    anotherIncoming: ['', [Validators.required]],
    monthlyIncome: [''],
    personalExpenses: ['', [Validators.required]],
    creditExpenses: ['', [Validators.required]],
    totalAssets: ['', [Validators.required]],
    totalLiabilities: ['', [Validators.required]],
    totalIncoming: [{ value: '', disabled: true }],
    requestedAmount: [0],
    applicationDate: [''],
    applicationStatus: ['PendingToApprove'],

    amount: ['', [Validators.required]],
    requestedTerm: [
      0,
      [Validators.required, Validators.min(1), Validators.max(24)],
    ],
    term: ['0'],
    tipoCredito: ['', Validators.required],

    bank: ['', [Validators.required]],
    accountType: ['', [Validators.required]],
    bankAccType: [''],
    accountNumber: ['', [Validators.required]],
    accNumber: ['', [Validators.required]],
  });

  currentTabIndex = 0; // Índice de la pestaña activa

  @ViewChild('newContactModal', { static: false })
  newContactModal: ModalDirective;
  @ViewChild('loadingModal', { static: false }) loadingModal?: ModalDirective;
  @ViewChild('loadingCreateModal', { static: false })
  loadingCreateModal?: ModalDirective;

  constructor(
    private modalService: BsModalService,
    public service: selfcreditService,
    private serviceListBank: UsersService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.user = {
      id: 0,
      name: 'Bakna',
      email: 'admin@bakna.co',
      address: 'Calle 10 25 - 35',
      webPage: 'https://www.bakna.co',
      phone: '3044419868',
      color: '#1c817d',
    };
    this.modalAbierto = false;
    this.anteriorTab = 0;
    this.actualTabValida = 0;
  }

  validateCurrentTab(): boolean {
    const currentTab = this.tabs[this.currentTabIndex];
    // Obtener controles del tab actual
    const tabControls = this.getTabControls(currentTab.id);
    // Verificar si hay errores en los controles del tab actual
    let hasErrors = false;
    Object.keys(tabControls).forEach((key) => {
      const control = this.requestForm.get(key);
      if (control && control.invalid) {
        //control.markAsTouched();
        hasErrors = true;
      }
    });
    return !hasErrors;
  }

  getTabControls(tabId: string): { [key: string]: any } {
    const controlsByTab: { [key: string]: { [key: string]: any } } = {
      personal: {
        name: this.requestForm.get('name'),
        lastName: this.requestForm.get('lastName'),
        fullName: this.requestForm.get('fullName'),
        documentType: this.requestForm.get('documentType'),
        documentNumber: this.requestForm.get('documentNumber'),
        customerDocument: this.requestForm.get('customerDocument'),
        country: this.requestForm.get('country'),
        department: this.requestForm.get('department'),
        city: this.requestForm.get('city'),
        address: this.requestForm.get('address'),
        birthDate: this.requestForm.get('birthDate'),
        cellPhone: this.requestForm.get('cellPhone'),
        //'documents': this.requestForm.get('documents'),
        email: this.requestForm.get('email'),
        gender: this.requestForm.get('gender'),
      },
      laboral: {
        employeeType: this.requestForm.get('employeeType'),
        enterpriseName: this.requestForm.get('enterpriseName'),
        contractType: this.requestForm.get('contractType'),
        neighborhood: this.requestForm.get('neighborhood'),
        position: this.requestForm.get('position'),
      },
      financiera: {
        incoming: this.requestForm.get('incoming'),
        anotherIncoming: this.requestForm.get('anotherIncoming'),
        monthlyIncome: this.requestForm.get('monthlyIncome'),
        personalExpenses: this.requestForm.get('personalExpenses'),
        creditExpenses: this.requestForm.get('creditExpenses'),
        totalAssets: this.requestForm.get('totalAssets'),
        totalLiabilities: this.requestForm.get('totalLiabilities'),
        totalIncoming: this.requestForm.get('totalIncoming'),
        requestedAmount: this.requestForm.get('requestedAmount'),
        applicationDate: this.requestForm.get('applicationDate'),
        applicationStatus: this.requestForm.get('applicationStatus'),
      },
      credito: {
        amount: this.requestForm.get('amount'),
        requestedTerm: this.requestForm.get('requestedTerm'),
        term: this.requestForm.get('term'),
        tipoCredito: this.requestForm.get('tipoCredito'),
      },
      bancaria: {
        bank: this.requestForm.get('bank'),
        accountType: this.requestForm.get('accountType'),
        bankAccType: this.requestForm.get('bankAccType'),
        accountNumber: this.requestForm.get('accountNumber'),
        accNumber: this.requestForm.get('accNumber'),
      },
    };
    return controlsByTab[tabId] || {};
  }

  setActiveTab(tabId: string, tab = {}): void {
    //console.log(tabId);
    //console.log(tab);

    if (tab['value'] > this.tabs[this.currentTabIndex].value) {
      // Validar tab actual antes de cambiar (opcional)
      if (!this.validateCurrentTab()) {
        Swal.fire({
          icon: 'warning',
          text: 'Completa todos los datos.',
        });
        return;
        // Decidir si permitir o no el cambio de tab
      }
    }
    this.activeTab = tabId;
    this.tabs = this.tabs.map((tab) => ({
      ...tab,
      active: tab.id === tabId,
    }));

    // Actualizar currentTabIndex
    this.currentTabIndex = this.tabs.findIndex((tab) => tab.id === tabId);
  }

  getTabClasses(isActive: boolean): string {
    return isActive
      ? 'border-blue-500 text-blue-600 hover:text-blue-700'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300';
  }

  trackByTab(index: number, tab: TabItem): string {
    return tab.id;
  }

  nextTab(tabId: string, tab = {}): void {
    const currentIndex = this.tabs.findIndex((tab) => tab.active);

    if (currentIndex < this.tabs.length - 1) {
      this.setActiveTab(tabId, tab);
    }
  }

  previousTab(): void {
    const currentIndex = this.tabs.findIndex((tab) => tab.active);
    if (currentIndex > 0) {
      this.setActiveTab(this.tabs[currentIndex - 1].id);
    }
  }

  isFirstTab(): boolean {
    return this.tabs.findIndex((tab) => tab.active) === 0;
  }

  isLastTab(): boolean {
    return this.tabs.findIndex((tab) => tab.active) === this.tabs.length - 1;
  }

  createReference(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      cellPhone: ['', [Validators.required]],
      bond: ['', Validators.required],
    });
  }

  ngAfterViewInit() {
    if (this.newContactModal) {
      this.newContactModal.show();
    }
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.userId = params['userId'];
      this.getUser(this.userId);
      //console.log(this.user);
    });

    this.serviceListBank.getListBank().subscribe(
      (resp) => {
        this.listBanks = resp.data;
      },
      (error) => {
        console.log(error, 'Error mostrando bancos');
      },
    );

    this.http.get('assets/divipola/colombia.json').subscribe((data: any) => {
      this.colombiaData = data;
      this.departamentos = data.map((d) => ({
        nombre: d.nombre_departamento,
        codigo: d.codigo_departamento,
      }));
    });
  }

  onDepartmentChange(event: any) {
    const deptCode = event.target.value;
    const dept = this.colombiaData.find(
      (d) => d.codigo_departamento == deptCode,
    );
    this.municipios = dept ? dept.municipios : [];
    this.requestForm.get('city').setValue('');
  }

  // Navegación entre pestañas
  goToTab(index: number): void {
    // Opcional: Podrías añadir lógica de validación aquí antes de cambiar de pestaña si es un requisito
    // if (index > this.currentTabIndex && !this.currentFormGroup.valid) {
    //   this.currentFormGroup.markAllAsTouched(); // Marca todos los campos como tocados para mostrar errores
    //   alert('Por favor, completa todos los campos requeridos antes de avanzar.');
    //   return;
    // }
    this.currentTabIndex = index;
  }

  getUser(userId) {
    if (userId == undefined) {
      return;
    }
    this.service.getUserPublic(userId).subscribe((resp: any) => {
      if (resp != null) {
        this.user = resp;

        this.isUser = true;
      } else {
        this.isUser = false;
        this.router.navigateByUrl('/self-credit', { replaceUrl: true });
      }
    });
  }

  formatNumberAsValue($input: HTMLInputElement) {
    return parseFloat($input.value.replace(/[^0-9]/g, '')).toLocaleString(
      'en-US',
    );
  }

  onDocumentNumberInputFrom(event: Event, controlador): void {
    const input = event.target as HTMLInputElement;
    this.requestForm.controls[controlador].setValue(
      this.formatNumberAsValue(input),
    );
    this.calculateTotalIncome();
  }

  getPersonalData() {
    if (this.requestForm.get('documentNumber').valid) {
      this.service
        .get(this.requestForm.get('documentNumber').value)
        .subscribe((reps: any) => {
          this.requestForm.get('name').setValue(reps.name);
          this.requestForm.get('lastName').setValue(reps.lastName);
          this.requestForm.get('documentType').setValue(reps.documentType);

          if (reps.city) {
            // Buscar departamento por código de municipio
            const cityCode = parseInt(reps.city);
            const dept = this.colombiaData.find((d) =>
              d.municipios.some((m) => m.codigo_municipio == cityCode),
            );

            if (dept) {
              this.municipios = dept.municipios;
              this.requestForm
                .get('department')
                .setValue(dept.codigo_departamento);
              setTimeout(() => {
                this.requestForm.get('city').setValue(reps.city);
              });
            } else {
              this.requestForm.get('city').setValue(reps.city);
            }
          }

          this.requestForm.get('address').setValue(reps.address);
          this.requestForm.get('phone').setValue(reps.phone);
          const birthDate = new Date(reps.birthDate)
            .toISOString()
            .split('T')[0];
          this.requestForm.get('birthDate').setValue(birthDate);
          this.requestForm.get('cellPhone').setValue(reps.cellPhone);
          this.requestForm.get('email').setValue(reps.email);
          this.requestForm.get('gender').setValue(reps.gender.toString());
          this.requestForm.get('stratum').setValue(reps.stratum);
          this.requestForm.get('cityBorn').setValue(reps.cityBorn);
          this.requestForm
            .get('maritalStatus')
            .setValue(reps.validMaritalStatus.toString());
          this.requestForm
            .get('houseType')
            .setValue(reps.validHouseType.toString());
          this.requestForm.get('housingTime').setValue(reps.housingTime);
          this.requestForm
            .get('academicLevel')
            .setValue(reps.validAcademicLevel.toString());
          this.requestForm
            .get('employeeType')
            .setValue(reps.validEmployeeType.toString());
          this.requestForm.get('enterpriseName').setValue(reps.enterpriseName);
          this.requestForm
            .get('contractType')
            .setValue(reps.validContractTypee.toString());
          this.id = reps.id.toString();
          this.haveUser = true;
        });
    }
  }

  calculateTotalIncome() {
    let n1 = this.requestForm.get('incoming').value
      ? this.requestForm.get('incoming').value.replace(/,/g, '')
      : 0;
    let n2 = this.requestForm.get('anotherIncoming').value
      ? this.requestForm.get('anotherIncoming').value.replace(/,/g, '')
      : 0;
    let suma1 = +n1 + +n2;
    this.requestForm
      .get('monthlyIncome')
      .setValue(suma1.toLocaleString('en-US'));
    this.requestForm
      .get('totalIncoming')
      .setValue(suma1.toLocaleString('en-US'));
  }

  createRequest() {
    this.loading = true;
    this.showLoading();
    if (this.requestForm.invalid) {
      this.requestForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    const countryCode = String(
      this.requestForm.get('country').value ?? '',
    ).trim();
    const stateCode = String(
      this.requestForm.get('department').value ?? '',
    )
      .trim()
      .padStart(2, '0');
    const cityCode = String(this.requestForm.get('city').value ?? '')
      .trim()
      .padStart(5, '0');

    const unifiedData = {
      ...this.requestForm.value,
      countryCode,
      stateCode,
      cityCode,
      applicationDate: new Date().toISOString(),
      incoming: parseInt(
        this.requestForm.controls['incoming'].value
          ? this.requestForm.controls['incoming'].value.replace(/,/g, '')
          : '0',
      ),
      anotherIncoming: parseInt(
        this.requestForm.get('anotherIncoming').value
          ? this.requestForm.get('anotherIncoming').value.replace(/,/g, '')
          : '0',
      ),
      personalExpenses: parseInt(
        this.requestForm.get('personalExpenses').value
          ? this.requestForm.get('personalExpenses').value.replace(/,/g, '')
          : '0',
      ),
      amount: parseInt(
        this.requestForm.get('amount').value
          ? this.requestForm.get('amount').value.replace(/,/g, '')
          : 0,
      ),
      requestedAmount: parseInt(
        this.requestForm.get('amount').value
          ? this.requestForm.get('amount').value.replace(/,/g, '')
          : 0,
      ),
      creditExpenses: parseInt(
        this.requestForm.get('creditExpenses').value
          ? this.requestForm.get('creditExpenses').value.replace(/,/g, '')
          : 0,
      ),
      totalAssets: parseInt(
        this.requestForm.get('totalAssets').value
          ? this.requestForm.get('totalAssets').value.replace(/,/g, '')
          : 0,
      ),
      totalLiabilities: parseInt(
        this.requestForm.get('totalLiabilities').value
          ? this.requestForm.get('totalLiabilities').value.replace(/,/g, '')
          : 0,
      ),
      monthlyIncome: parseInt(
        this.requestForm.get('monthlyIncome').value
          ? this.requestForm.get('monthlyIncome').value.replace(/,/g, '')
          : 0,
      ),
      totalIncoming: parseInt(
        this.requestForm.get('totalIncoming').value
          ? this.requestForm.get('totalIncoming').value.replace(/,/g, '')
          : 0,
      ),
      partnerId: this.userId,
      assignedUserId: this.userId,
      status: 1,
      interestRate: 0,
    };
    unifiedData['customerDocument'] = unifiedData.documentNumber;
    unifiedData['term'] = unifiedData.requestedTerm.toString();
    unifiedData['bankAccType'] = unifiedData.accountType;
    unifiedData['accNumber'] = unifiedData.accountNumber;
    unifiedData['fullName'] = unifiedData.name + ' ' + unifiedData.lastName;
    //console.log(unifiedData);

    firstValueFrom(this.service.createCustomer(unifiedData))
      .then((resp: any) => {
        unifiedData['customerId'] = resp.data.customerId;
        firstValueFrom(this.service.saveUser(unifiedData)).then(
          (respL: any) => {
            //console.log(respL);
            Swal.close();
            Swal.fire({
              icon: respL.success ? 'success' : 'error',
              text: respL.error ? respL.data : respL.error,
            });
            this.loading = false;
          },
        );
      })
      .catch(() => {
        Swal.close();
        Swal.fire({
          icon: 'error',
          text: 'Error del sistema',
        });
        this.loading = false;
      });
  }

  showLoading() {
    let timerInterval;
    Swal.fire({
      title: 'Solicitud de crédito.',
      html: 'Creando tu solicitud.',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    });
  }

  openModal() {
    this.modalAbierto = true;
  }

  closeModal() {
    this.modalAbierto = false;
  }

  validacionDocumento() {
    let document1 = this.requestForm.get('documentNumber').value;
    let document2 = this.requestForm.get('accNumber').value;

    if (document1 == document2) {
      this.validateDocument = false;
      //console.log(document1, document2, this.validateDocument);

      return;
    }
    this.validateDocument = true;
    //console.log(document1, document2, this.validateDocument);
    return;
  }

  validacionInputReq(fieldName: string): boolean | null {
    return (
      this.requestForm.controls[fieldName].errors &&
      this.requestForm.controls[fieldName].touched
    );
  }
}
